var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M32.0603 0.351562H3.88531C3.00685 0.353938 2.16505 0.703958 1.54388 1.32513C0.922708 1.9463 0.572688 2.7881 0.570312 3.66656V24.3836C0.572688 25.262 0.922708 26.1038 1.54388 26.725C2.16505 27.3462 3.00685 27.6962 3.88531 27.6986H32.0603C32.9388 27.6962 33.7806 27.3462 34.4017 26.725C35.0229 26.1038 35.3729 25.262 35.3753 24.3836V3.66656C35.3729 2.7881 35.0229 1.9463 34.4017 1.32513C33.7806 0.703958 32.9388 0.353938 32.0603 0.351562ZM31.6463 7.39556L17.9703 16.5106L4.29931 7.39556V4.08056L17.9703 13.1966L31.6433 4.08157L31.6463 7.39556Z","fill":"#2CD0DB"}));
}

Envelope.defaultProps = {"width":"36","height":"28","viewBox":"0 0 36 28","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
